import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PhysicalDock } from 'contracts/PhysicalDocks';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  { prefix: 'FETCH_PHYSICAL_DOCK_' }
);

export interface FetchPhysicalDockState {
  data: PhysicalDock | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchPhysicalDockRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PhysicalDock;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchPhysicalDockState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchPhysicalDockState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchPhysicalDockState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchPhysicalDockState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchPhysicalDockState) =>
  update(state, { loading: { $set: false } });

const reset = () => INITIAL_STATE;

export const fetchPhysicalDock = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchPhysicalDockTypes = Types;
export const FetchPhysicalDockActions = Creators;
